import {FLIP_CARD_SIDE} from '../../../incase-domain/elements/flipCard';

export interface IFlipCardAction {
    type: typeof FLIP_CARD;
    payload: {
        elementId: string;
        flipCardSide: FLIP_CARD_SIDE;
    };
}

export const FLIP_CARD = 'FLIP_CARD';

export type FlipCardReducerType = IFlipCardAction;
